import * as moment from 'moment-timezone';
import 'moment/locale/th'; // without this line it didn't work

moment.tz.setDefault('Asia/Bangkok');
moment.locale('th');

export default moment;
